/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-21 15:54:46
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-05-20 16:59:42
 * @FilePath: \baishu_react_ui\src\components\BsyLinkData\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from "react";

import { BsyWidget } from "../BsyWidget";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import { ShowDataListPane } from "../BsyLinkData";
import BsyDialog from "../BsyDialog";

export default class BsySubformLinkData extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-subform-link-data",
      allowBlank: !0,
      linkFields: [],
      linkKey: null,
      linkFilter: [],
      linkForm: null,
      itemsPerPage: 200,
      data: {},
      onBeforeLinkData: null,
      refType: null,
      allowAdd: !1, //是否有创建数据的权限
      popupFormPath: [],
      ...props,
    });
    // console.log('BsySubformLinkData')
    this.value = props.value || {};
    this.state = {
      data: props.data || {},
    };
  }

  componentDidMount() {
    super.componentDidMount();
    if (BsyUtils.isObjectEmpty(this.state.data)) {
      this.readData();
    }
  }

  readData = () => {
    let that = this;
    if (!BsyUtils.isObjectEmpty(this.value)) {
      let config = {
        designAppId: this.options.designAppId,
        designEntryId: this.options.designEntryId,
        designDataId: this.options.designDataId,
        appId: this.options.appId,
        entryId: this.options.entryId,
        formId: this.options.linkForm,
        linkId: this.value.id,
        refAppId: this.options.refAppId || this.options.appId,
        widgetName: this.options.widgetName,
        subformName: this.options.subform,
      };
      React.axios(`/data/read_link`, config).then((res) => {
        BsyUtils.showAjaxTip(
          res.data,
          () => {
            this.setState({ data: res.data.data }, () => {
              BsyUtils.applyFunc(
                that,
                that.options.onAfterEdit,
                [that.value, null, that],
                !1
              );
            });
          },
          () => {}
        );
      });
    }
  };

  getValue = () => {
    if (BsyUtils.isObjectEmpty(this.value)) {
      return null;
    }
    if (BsyUtils.isObjectEmpty(this.value.id)) {
      return null;
    }
    this.value.appId = this.options.refAppId;
    this.value.entryId = this.options.linkForm;
    this.value.linkType = this.options.linkType;
    return this.value;
  };

  setValue = (t) => {
    if (BsyUtils.isObjectEmpty(t)) this.value = null;
    else {
      this.value = { ...t };
      this.readData();
    }
  };

  loadData = (e) => {
    // /data/filter
    this.showDataList(e.currentTarget);
  };

  showDataList = (currentTarget) => {
    let that = this;
    if (!this.isEnabled()) return;
    let fieldHasKey = false;
    let tlinkFields = that.options.linkFields.map((linkField) => {
      if (linkField.type === "subform") {
        return {
          ...linkField,
          items: linkField.items.map((i) => {
            return Object.assign({}, i.widget, {
              name: i.widget.widgetName,
              text: i.label,
              type: i.widget.type,
            });
          }),
        };
      } else {
        linkField.name == that.options.linkKey && (fieldHasKey = true);
        return linkField;
      }
    });
    if (BsyUtils.isObjectEmpty(tlinkFields)) {
      tlinkFields = [
        {
          name: "label",
          text: "标题",
          type: "textarea",
        },
      ];
    }
    if (that.options.linkKey && !fieldHasKey) {
      tlinkFields.push({
        name: that.options.linkKey,
        text: React.language("field.key"),
        type: that.options.linkType,
        detailOnly: true,
      });
    }

    BsyDialog({
      title: React.language("widget.linkdata.select"),
      height: 600,
      width: 800,
      noFooter: true,
      onContentCreate: (ref) => {
        return (
          <ShowDataListPane
            onSelect={(e) => {
              if (that.value && that.value.id == e._id) {
                that.setState(
                  {
                    data: {},
                  },
                  () => {
                    that.value = null;
                    BsyUtils.applyFunc(
                      that,
                      that.options.onStopEdit,
                      [that.value, null, that],
                      !1
                    );
                  }
                );
              } else {
                that.setState(
                  {
                    data: e,
                  },
                  () => {
                    if (e) {
                      that.value = {
                        appId: that.options.refAppId,
                        entryId: that.options.linkForm,
                        id: e._id,
                        key: that.options.linkKey
                          ? e[that.options.linkKey]
                          : "",
                      };
                    } else {
                      that.value = null;
                    }
                    BsyUtils.applyFunc(
                      that,
                      that.options.onStopEdit,
                      [that.value, null, that],
                      !1
                    );
                  }
                );
              }

              ref.closeAlter();
            }}
            {...that.options}
            linkFields={[...tlinkFields]}
            baseCls="bsy-show-data-list-pane"
            getContext={null}
            value={this.value}
          />
        );
      },
    });
  };

  renderField = (item) => {
    const { data } = this.state;
    let value = data ? data[item.name] : "";

    let config = { ...item };
    config.value = value;
    config.enable = false;
    const { appId, dataId, formId } = this.options;
    config.appId = appId;
    config.dataId = dataId;
    config.formId = formId;
    if (config.type == "location ") {
      config.enablePcLocation = true;
    }

    return <div className="link-field">{BsyUtils.createWidget(config)}</div>;
  };

  render() {
    const { css, cssName, linkFields } = this.options;
    return (
      <div className={cssName}>
        {
          <div
            className={"select-data " + (this.isEnabled() ? "enabled" : "")}
            onClick={this.loadData}
          >
            <i className={"icon-bsy-iconguanlianshuju"}></i>
          </div>
        }

        <div className="field-list" key={BsyUtils.Ids24()}>
          {linkFields.map((e) => {
            return this.renderField(e);
          })}
        </div>
      </div>
    );
  }
}
